import { DemoModal } from "../components/DemoModal";
import { ClientStoriesModal } from "../components/ClientStoriesModal";
import { BookMeetingModalTest } from "../components/meetings-test/BookMeetingModalTest";
import { MeetingDetailsModal } from "../components/meetings/MeetingDetailsModal";
import { MeetingSummaryModal } from "../components/meetings/MeetingSummaryModal";
import { SelectMeetingDateModal } from "../components/meetings/SelectMeetingDateModal";

export const ModalProvider = () => {
  return (
    <>
      <SelectMeetingDateModal />
      <MeetingDetailsModal />
      <DemoModal />
      <ClientStoriesModal />
      <MeetingSummaryModal />
      <BookMeetingModalTest />
    </>
  );
};
